var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "referrer-linked-profiles",
      "store-path": "referrerLinkedProfiles",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("referrers.messages.profilesAssociated")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("referrer-linked-profiles-loader")
              : !_vm.isEmpty
              ? _c(
                  "b-row",
                  _vm._l(_vm.profiles, function (ref) {
                    var clientProfileId = ref.clientProfileId
                    var boardId = ref.boardId
                    var givenName = ref.givenName
                    var familyName = ref.familyName
                    var email = ref.email
                    var phoneNumber = ref.phoneNumber
                    var labelName = ref.labelName
                    var boardName = ref.boardName
                    var active = ref.active
                    return _c(
                      "b-col",
                      {
                        key: clientProfileId,
                        staticClass: "pb-3",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "small text-primary bold btn-view-app",
                                    attrs: {
                                      to: _vm.clientProfileLink(
                                        clientProfileId,
                                        boardId
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "capitalize",
                                        staticStyle: { "font-size": "1rem" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("fullName")({
                                                givenName: givenName,
                                                familyName: familyName,
                                              })
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "small text-gray mb-0 regular-line-height",
                                },
                                [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("boards.messages.boardName")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(boardName) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "small text-gray mb-0 regular-line-height",
                                },
                                [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("global.words.status")) +
                                        ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.LABEL_LINKED_PROFILES(labelName)
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "small text-gray mb-0 regular-line-height",
                                },
                                [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("client-profile.profileState")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        active
                                          ? _vm.$t("global.words.active")
                                          : _vm.$t("global.words.inactive")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "small text-gray mb-0 regular-line-height",
                                },
                                [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("global.words.phone")) + ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(phoneNumber) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "small text-gray mb-0 regular-line-height",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "bold capitalize" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$tc("global.words.email", 1)
                                        ) + ":"
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(email) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                )
              : _c(
                  "b-row",
                  { staticClass: "justify-content-center" },
                  [
                    _c(
                      "no-results",
                      {
                        attrs: {
                          "img-src": require("@Broker/@Assets/icon/empty-timeline.png"),
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("referrers.messages.thereAreNoProfiles")
                            ) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }